import TextField from "@mui/material/TextField";
import ButtonLoading from "../Button/ButtonLoading";
import React, { useState } from "react";
import { Link } from "react-router";
import { Button, Stack, Typography } from "@mui/material";
import { CustomerFeedback } from "../../types/Entities/CustomerFeedback";
import CustomerRatingPlatformPrompt from "./CustomerRatingPlatformPrompt";

type FeedbackProps = {
  feedbackEntity: CustomerFeedback;
  stars: number;
  saveFeedback: (feedback: Partial<CustomerFeedback>) => void;
};

export default function FeedbackComment({ feedbackEntity, stars, saveFeedback }: FeedbackProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [comment, setComment] = useState<string | undefined>(undefined);

  if (!!feedbackEntity.feedbackDateTime) {
    if (feedbackEntity.isFinalReview && feedbackEntity.stars === 5) {
      return <CustomerRatingPlatformPrompt customerFeedback={feedbackEntity} />;
    }
    return (
      <>
        <Typography sx={{ marginBottom: "1rem" }}>Ihre Bewertung {!!feedbackEntity.comment ? "und Ihr Kommentar wurden" : "wurde"} gespeichert</Typography>
        <Button sx={{ marginLeft: { md: "auto" } }} variant="outlined" component={Link} to={"/servicewelt"}>
          Zu meiner Servicewelt
        </Button>
      </>
    );
  }

  const handleSubmit = () => {
    setIsLoading(true);

    const updatedFeedback: Partial<CustomerFeedback> = {
      case: feedbackEntity.case,
      isFinalReview: feedbackEntity.isFinalReview,
      source: feedbackEntity.source,
      hash: feedbackEntity.hash,
      comment: comment,
      stars: stars,
    };

    saveFeedback(updatedFeedback);

    setIsLoading(false);
  };

  return (
    <>
      {feedbackEntity.source !== "footer" ? (
        <>
          <Typography>Bitte hinterlassen Sie uns noch einen kurzen Kommentar zu Ihrer Bewertung.</Typography>
          <TextField
            sx={{ marginBottom: "1rem" }}
            label="Ihr Kommentar"
            name="comment"
            value={comment}
            onChange={({ target }) => setComment(target.value)}
            multiline
            rows="4"
            maxRows="4"
            margin="normal"
            fullWidth
          />
        </>
      ) : (
        <Typography sx={{ marginBottom: "1rem" }}>Mit Ihrer Bewertung helfen Sie uns dabei, uns verbessern zu können.</Typography>
      )}
      <Stack sx={{ marginBottom: "1rem" }}>
        <ButtonLoading sx={{ marginLeft: { md: "auto" } }} color="primary" variant="outlined" onClick={handleSubmit} isLoading={isLoading} disabled={!stars}>
          Bewertung speichern
        </ButtonLoading>
      </Stack>
      <Button fullWidth color="primary" component={Link} to={"/servicewelt"}>
        Zu meiner Servicewelt
      </Button>
    </>
  );
}
